import * as stylex from "@stylexjs/stylex";
import {
  spacing,
  fonts,
  fontSizes,
  colors,
  radii,
} from "@softmax/design-system/tokens.stylex";
const entry = stylex.keyframes({
  from: { opacity: 0, transform: "translateY(4px)" },
  to: { opacity: 1, transform: "translateY(0)" },
});

const checkDraw = stylex.keyframes({
  from: { strokeDashoffset: 25 },
  to: { strokeDashoffset: 0 },
});

export const styles = stylex.create({
  connectionStatus: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    gap: spacing.space8,
  },
  list: {
    position: "relative",
    containerType: "inline-size",
    display: "flex",
    flexDirection: "column",
    gap: spacing.space20,
    listStyle: "none",
    padding: 0,
    margin: 0,
  },
  row: {
    display: "flex",
    gap: 14,
    alignItems: "flex-start",
    scrollMarginTop: spacing.space16,
    scrollMarginBottom: 28,
  },
  activeRow: { marginTop: { default: spacing.space12, ":first-child": 0 } },
  rowBody: {
    minWidth: 0,
    flex: 1,
    display: "flex",
    flexDirection: "column",
    gap: spacing.space12,
    paddingTop: 3,
  },
  enter: {
    animationName: {
      default: entry,
      "@media (prefers-reduced-motion: reduce)": "none",
    },
    animationDuration: "250ms",
    animationTimingFunction: "ease-out",
  },
  hidden: {
    position: "absolute",
    width: 1,
    height: 1,
    padding: 0,
    margin: -1,
    overflow: "hidden",
    clip: "rect(0, 0, 0, 0)",
    whiteSpace: "nowrap",
    borderWidth: 0,
  },
  title: {
    margin: 0,
    fontFamily: fonts.sans,
    fontSize: 18,
    lineHeight: "26px",
    fontWeight: 600,
    color: colors.foreground,
  },
  copy: {
    margin: 0,
    fontFamily: fonts.sans,
    fontSize: fontSizes.reading,
    lineHeight: "22px",
    color: colors.muted,
  },
  small: { fontSize: fontSizes.label, lineHeight: "20px" },
  counter: {
    margin: 0,
    fontFamily: fonts.mono,
    fontSize: 11,
    lineHeight: "16px",
    color: colors.muted,
  },
  error: { color: colors.danger },
  foreground: { color: colors.foreground },
  result: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "baseline",
    columnGap: spacing.space10,
    rowGap: spacing.space4,
  },
  machine: {
    fontFamily: fonts.mono,
    fontSize: fontSizes.reading,
    whiteSpace: "nowrap",
    color: colors.foreground,
  },
  avatar: {
    width: 20,
    height: 20,
    flexShrink: 0,
    alignSelf: "center",
    borderRadius: radii.pill,
    objectFit: "cover",
  },
  badge: {
    position: "relative",
    display: "flex",
    width: 19,
    height: 15,
    flexShrink: 0,
    alignItems: "center",
    justifyContent: "center",
  },
  activeBadge: { marginTop: 7 },
  doneBadge: { marginTop: spacing.space6 },
  finaleBadge: { marginTop: 9 },
  svg: { width: "100%", height: "100%" },
  bars: { fill: colors.muted },
  check: { stroke: colors.foreground },
  drawCheck: {
    animationName: {
      default: checkDraw,
      "@media (prefers-reduced-motion: reduce)": "none",
    },
    animationDuration: "420ms",
    animationFillMode: "forwards",
    animationTimingFunction: "ease-out",
  },
  finale: { position: "relative", marginTop: 28 },
  action: { alignSelf: "flex-start" },
});
